
<form [formGroup]="form">
    <div class="row mt-2" *ngIf="mostrarVia">
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_DOMICILIO.TIPO_VIA' | translate}}</ca-label>
                <ca-select
                    keyValue="descTipoVia"
                    valueField="codTipoVia"
                    [options]="tiposVia"
                    [formControlName]="prefijoPersona + 'tipo-via'" 
                ></ca-select>
                <ca-error *ngIf="form.controls[prefijoPersona + 'tipo-via'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_DOMICILIO.DOMICILIO' | translate}}</ca-label>
                <input 
                    caInput 
                    type="text" 
                    placeholder="{{'COMUN.DATOS_DOMICILIO.DOMICILIO' | translate}}"
                    [formControlName]=" prefijoPersona + 'nombre-via'"/>
            </ca-form-field>
            <ca-error *ngIf="form.controls[prefijoPersona + 'nombre-via'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </div>
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_DOMICILIO.PISO' | translate}}</ca-label>
                <input 
                    caInput 
                    type="text" 
                    placeholder="{{'COMUN.DATOS_DOMICILIO.PISO' | translate}}"
                    [formControlName]="prefijoPersona + 'numero-via'"/>
            </ca-form-field>
            <ca-error  *ngIf="form.controls[ prefijoPersona + 'numero-via'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-4" *ngIf="mostrarLocalidad">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_DOMICILIO.CP' | translate}}</ca-label>
                <input 
                    caInput 
                    type="text" 
                    (change)="cambioCodPostal($event)"
                    placeholder="{{'COMUN.DATOS_DOMICILIO.CP' | translate}}"
                    [formControlName]="prefijoPersona + 'cod-postal'" />
            </ca-form-field>
        </div>
        <div class="col-4" *ngIf="mostrarLocalidad">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_DOMICILIO.LOCALIDAD' | translate}}</ca-label>
                <ca-select
                    keyValue="descPoblacion"
                    valueField="codPoblacion"
                    [options]="localidades"
                    [formControlName]=" prefijoPersona + 'localidad'" 
                ></ca-select>
                <ca-error *ngIf="form.controls[prefijoPersona + 'localidad'].errors?.required"> {{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
        <div class="col-4" *ngIf="provincias?.length > 0 && mostrarProvincia">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_DOMICILIO.PROVINCIA' | translate}}</ca-label>
                <ca-select
                    keyValue="descProvincia"
                    valueField="idProvincia"
                    [options]="provincias"
                    [formControlName]="prefijoPersona + 'provincia'" 
                ></ca-select>
                <ca-error *ngIf="form.controls[prefijoPersona + 'provincia'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
    </div>
</form>